import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_OPTIONS } from "../utils/constants";
import { addTrailerVideo } from "../utils/moviesSlice";
const useMovieTrailer = (movieId) => {
    // Fetch data from API 
    const dispatch = useDispatch();
    const trailerVideo = useSelector((store) => store.movies.trailerVideo)

    const getMovieVideos = async (movieId) => {
        const data = await fetch('https://api.themoviedb.org/3/movie/' + movieId + '/videos?language=en-US', API_OPTIONS);
        const json = await data.json();

        const filterData = json.results.filter((video) => {
            return video.type === "Trailer";
        });

        const trailer = filterData.length ? filterData[0] : json.results[0];



        dispatch(addTrailerVideo(trailer));
    }
    useEffect(() => {
        !trailerVideo && getMovieVideos(movieId);
    }, [dispatch]);
}

export default useMovieTrailer;